<script setup lang="ts">
import SettingsHomeCard from '@/settingsModule/components/SettingsHomeCard.vue';
import SettingsPageTitle from '@/settingsModule/components/SettingsPageTitle.vue';
import { i18n } from '@/i18n';

const t = i18n.t;
</script>

<template>
  <section class="settings-home">
    <SettingsPageTitle :label="t('設定')" />
    <div class="settings-home__card-list">
      <SettingsHomeCard
        to="/settings/templates/order"
        :title="t('書式・帳票')"
        :description="t('発注書や帳票の出力書式を管理')"
        :features="[t('発注出力形式登録・編集')]"
      />
      <SettingsHomeCard
        to="/settings/logic"
        :title="t('発注・計算ロジック')"
        :description="t('発注作成と計算の条件設定など')"
        :features="[t('発注作成条件'), t('内示計算設定')]"
      />
      <SettingsHomeCard
        to="/settings/format"
        :title="t('出力日付フォーマット')"
        :description="t('出力時の日付表示形式を設定')"
        :features="[t('日付フォーマット選択')]"
      />
    </div>
  </section>
</template>

<style scoped lang="scss">
.settings-home {
  display: grid;
  gap: 24px;
  padding: 24px;

  &__card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;
    justify-content: start;
  }
}
</style>
